import { Redirect, Switch } from "react-router-dom";
import PrivateRoute from "utils/PrivateRoute";
import injectReducer from "utils/injectReducer";
import reducer from "containers/PatientDataPage/reducer";
import injectSaga from "utils/injectSaga";
import saga from "containers/PatientDataPage/saga";
import { compose } from "redux";
import PatientDataPage from "containers/PatientDataPage/PatientDataPage";
import NewPatientPage from "containers/PatientDataPage/NewPatientPage";

function PatientDataRouting() {
  return (
    <Switch>
      <PrivateRoute
        path="/patients/new"
        component={NewPatientPage}
        needsPractice
      />
      <PrivateRoute
        path="/patient/:patientId/productplan/:productplanid"
        component={PatientDataPage}
        needsPractice
      />
      <PrivateRoute
        path="/patient/:patientId/:messageId?"
        component={PatientDataPage}
        needsPractice
      />
      <Redirect to="/login" />
    </Switch>
  );
}

const withReducer = injectReducer({ key: "patientDataPage", reducer });
const withSaga = injectSaga({ key: "patientDataPage", saga });

export default compose(
  withReducer,
  withSaga,
)(PatientDataRouting);
